import { Navigate } from 'react-router-dom';

import { useAuth } from '../../../contexts/AuthContext';

function ProtectedMemberRoute({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.type !== 'member') {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedMemberRoute;
